module.exports = __webpack_public_path__ + "img/smartwatches.948f1831.png";